<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        class="popup"
        v-show="visible"
        :class="{ 'popup_big': popupBig, [className]: className }"
      >
        <slot />
      </div>
    </transition>
    <transition name="fade">
      <div class="bgPopup" v-show="visible" @click="close"></div>
    </transition>
  </Teleport>
</template>

<script>
import Teleport from 'vue2-teleport'
export default {
  name: 'BaseModalRamadan',
  components: {
    Teleport
  },
  props: {
    popupBig: { type: Boolean, default: false },
    className: { type: String, default: '' },
    visible: { type: Boolean, default: false }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transition: opacity .05s;
}
</style>
